import React from 'react'
import PropTypes from 'prop-types'
import XmarkIcon from '../ui/icons/XmarkIcon'

const ModalHeader = ({ title, onClose }) => (
  <div className="tw:flex tw:items-center tw:justify-between tw:bg-white tw:px-4 tw:pt-4">
    <h5 className="tw:text-lg! tw:font-medium! tw:text-gray-900! tw:m-0!">{title}</h5>
    <button
      aria-label="Fermer la modale"
      className={'tw:bg-transparent tw:border-0 tw:w-10 tw:h-10 tw:flex tw:items-center '
        + 'tw:justify-center tw:cursor-pointer tw:text-gray-600 tw:hover:text-gray-900'}
      type="button"
      onClick={onClose}
    >
      <XmarkIcon className="tw:w-5 tw:h-5" />
    </button>
  </div>
)

ModalHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired
}

export default ModalHeader
